import React, { useState, useRef, useLayoutEffect } from "react";
import ContainerCard from "./containerCard";
import SectionHeading from "./sectionHeading";
import { useGlobalContext } from "../../utils/globalContext";
import { Chevron } from "@speedoc/design-assets/build/icons/index";
import { useMediaQuery } from "react-responsive";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function BenefitsDropdown({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });
  const [open, setOpen] = useState(undefined);
  const [grow, setGrow] = useState(false);
  const [cardClickable, setCardClickable] = useState(true);
  const [cardPosition, setCardPosition] = useState({});
  const [cardHeight, setCardHeight] = useState(0);
  const { Trans } = useGlobalContext();
  const cardBox = useRef({});
  const expandedCard = useRef();

  useLayoutEffect(() => {
    setCardHeight(cardBox.current.firstChild.offsetHeight);
  }, [cardBox.current.offsetHeight]);

  const resetClick = () => {
    return new Promise(resolve => {
      setTimeout(() => {
        setCardClickable(true);
        resolve();
      }, 900);
    });
  };

  const growCard = () => {
    return new Promise(resolve => {
      setTimeout(() => {
        setGrow(true);
        resolve();
      }, 100);
    });
  };

  const openCard = (e, index) => {
    if (!cardClickable) return;
    setCardClickable(false);
    setOpen(index === open ? undefined : index);
    setCardPosition({ left: e.currentTarget.offsetLeft, top: e.currentTarget.offsetTop });
    growCard().then(resetClick);
  };

  const closeCard = () => {
    if (!cardClickable) return;
    setCardClickable(false);
    setGrow(false);
    setTimeout(() => {
      setCardClickable(true);
      setOpen(undefined);
    }, 1000);
  };

  return (
    <div id="benefitsDropdown">
      <SectionHeading title={isMobile ? content.mobileTitle : content.title} subtitle={content.subtitle} />
      <div className="benefitsBody">
        <div className="benefitCards" ref={cardBox}>
          {content.list.map((card, index) => (
            <div key={index} onClick={e => openCard(e, index)}>
              <ContainerCard key={index}>
                <div className="cardTitle">
                  <Chevron />
                  <p className="title" dangerouslySetInnerHTML={{ __html: card.title }} />
                </div>
              </ContainerCard>
            </div>
          ))}
          {open !== undefined ? (
            <div
              className={`benefitOpenCardContainer ${grow ? "grow" : ""}`}
              style={{ marginTop: cardPosition?.top }}
              onClick={closeCard}>
              <div
                ref={expandedCard}
                className={`benefitOpenCard ${grow ? "grow" : ""}`}
                style={{ height: cardHeight }}>
                <ContainerCard>
                  <div className={"cardTitle"}>
                    <Chevron />
                    <p className="title">
                      <Trans>{content.list[open]?.title}</Trans>
                    </p>
                  </div>
                  <p className={`cardContent ${grow ? "fullOpacity" : ""}`}>{content.list[open]?.text}</p>
                </ContainerCard>
              </div>
            </div>
          ) : null}
        </div>
        {!isMobile && content.image?.url && (
          <div className="imageContainer">
            <LazyLoadImage src={content.image?.url} alt="Speedoc benefits" effect="blur" />
          </div>
        )}
      </div>
    </div>
  );
}
